import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Search/SearchResults/searchResults.container"
    ).then((module) => ({ default: module.SearchResultsContainer }))
);
